<template lang="pug">
  v-container
    v-layout(text-center wrap)
      v-flex(xs12)
        v-img(
          :src="require('@/assets/nouhinsyo.svg')"
          class="my-3"
          contain
          height="200"
        )
      v-flex(mb-4)
        h1.display-2.font-weight-bold.mb-3
          | 売上伝票作成
        p.subheading.font-weight-regular(v-if="!isLogin")
          | このサイトの使用は、登録済みのユーザーに限定されています。
          br
          | 使用するには、ログインして下さい。
          br
          a(href="/#/login") ログイン
        p.subheading.font-weight-regular(v-if="isLogin")
          | メインメニューからスタートして下さい。
          br
          a(href="/#/sales_slip") メインメニュー
</template>

<script>
export default {
  name: "HelloWorld",
  computed: {
    isLogin: function() { return this.$store.getters.isLogin }
  },
}
</script>
